<div class="flex gap-4">
  <div class="w-50">
    <elcia-invoice-product-dropdown
      (nameResolved)="fg().controls.label.setValue($event)"
      (productSelected)="onProductSelected($event)"
      (unitPriceResolved)="fg().controls.unitPrice.setValue($event)"
      [control]="fg().controls.productId"
      [invoiceDate]="creditNoteDate()"
      [isMulti]="false"
      [legalEntityId]="legalEntityId()"
    />
  </div>
  <div class="flex-1">
    <elcia-text-input [control]="fg().controls.label" [label]="'credit-note.label' | translate"/>
  </div>
  <div class="w-50">
    <elcia-numeric-input [control]="fg().controls.quantity" [label]="'credit-note.quantity' | translate"
                         mode="decimal"/>
  </div>
  <div class="w-50">
    <elcia-numeric-input [control]="fg().controls.unitPrice" [label]="'credit-note.unit-price' | translate"
                         currency="EUR" mode="currency"/>
  </div>
  <div class="w-50">
    <elcia-numeric-input [control]="amountOfLine" [label]="'invoice.amount' | translate"
                         currency="EUR" mode="currency"/>
  </div>
  <div class="w-50">
    <elcia-tax-dropdown [control]="fg().controls.taxId" [isMulti]="false"/>
  </div>
  <div class="flex items-center gap-2 self-center">
    <elcia-button (onClick)="toggleDescription()"
                  [icon]="'align-center'"
                  [severity]="descriptionVisible() ? 'primary' : 'secondary'"
    />
    <elcia-button (onClick)="remove()" [icon]="'minus'" [severity]="'secondary'"/>
  </div>
</div>

@if (descriptionVisible()) {
  <!-- Tighter top margin than the parent's gap-4 so the description stays grouped with this line, not the next one -->
  <div class="mt-2">
    <elcia-text-area [control]="fg().controls.description" [label]="'invoice.description' | translate" [rows]="2"/>
  </div>
}
